<template>
  <div name="adminArticle">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">文章列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">話題</li>
              <li class="breadcrumb-item active">文章列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-article" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-2">
            <el-input
              clearable
              placeholder="搜尋文章標題"
              v-model="filterParam.title"
            ></el-input>
          </div>
          <div class="col-sm-2">
            <el-input
              clearable
              v-model="filterParam.author"
              placeholder="搜尋作者"
            ></el-input>
          </div>
          <div class="col-sm-4">
            <el-select
              v-model="filterParam.topicType"
              clearable
              placeholder="請選擇文章類型"
            >
              <el-option
                v-for="type in topicTypeList"
                :key="type.id"
                :label="type.sgL_NewName"
                :value="type.id"
              ></el-option>
            </el-select>
            <!-- <el-select
              v-model="filterParam.SGL_Recommend"
              clearable
              placeholder="是否推薦"
            >
              <el-option label="是" value="true"></el-option>
              <el-option label="否" value="false"></el-option>
            </el-select> -->
          </div>
          <div class="col-sm-2"></div>
          <div class="col-sm-2">
            <button
              @click="toArtivleAdd()"
              type="button"
              class="btn btn-block btn-primary btn-sm"
            >
              <i class="nav-icon fas fa-pen fa-sm mr-1"></i>撰寫文章
            </button>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table
                  :data="getTopicModel"
                  :stripe="true"
                  row-key="id"
                  border
                  v-loading="isload"
                  @cell-click="cellclick"
                >
                  <!-- <el-table-column label="精選" align="center">
                    <template slot-scope="scoped">
                      <span v-if="scoped.row.sgL_Recommend">
                        <i class="el-icon-star-on"></i>
                      </span>
                      <span v-else>
                        <i class="el-icon-star-off"></i>
                      </span>
                    </template>
                  </el-table-column> -->

                  <el-table-column label="文章標題" width="460">
                    <template slot-scope="scope">
                      <router-link
                        target="_blank"
                        :title="scope.row.sgL_KMKeyworld"
                        v-bind:to="{
                          name: 'articleview',
                          query: {
                            id: scope.row.id,
                          },
                        }"
                      >
                        <div class="b-article-block mr-2 clearfix">
                          <div class="b-article-thumbnail">
                            <div class="b-article-responsive">
                              <div class="b-article-sizer">
                                <div
                                  class="b-article-image"
                                  :style="{
                                    backgroundImage:
                                      'url(' +
                                      `${scope.row.sgL_ImageUrl}` +
                                      ')',
                                  }"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <span class="b-title">
                          {{ scope.row.sgL_Title }}
                        </span>
                        <span class="b-tag">
                          <a
                            v-for="tag in scope.row.sgL_NKeywordF"
                            v-bind:key="tag"
                            >{{ tag }}</a
                          >
                        </span>
                      </router-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="作者"
                    width="100"
                    prop="sgL_DisplayName"
                  >
                    <template slot-scope="scope">
                      <el-link type="primary">{{
                        scope.row.sgL_DisplayName
                      }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="類型"
                    width="120"
                    prop="sgL_MasterSortF"
                  >
                    <template slot-scope="scope">
                      <el-link type="primary">{{
                        scope.row.sgL_MasterSortF
                      }}</el-link>
                    </template></el-table-column
                  >
                  <el-table-column label="發佈日期 / 狀態" width="190">
                    <template slot-scope="scope">
                      <span>{{ scope.row.sgL_CreateTimeM }}</span>
                      <br />
                      <span
                        v-if="scope.row.sgL_NStatus == true"
                        class="b-published"
                        >已發佈</span
                      >
                      <span v-else class="b-unpublished">未發佈</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="瀏覽量"
                    prop="sgL_NViewQuantity"
                  ></el-table-column>
                  <!-- <el-table-column
                    label="讚好"
                    prop="sgL_Praise"
                  ></el-table-column>
                  <el-table-column
                    label="留言"
                    prop="sgL_NMessage"
                  ></el-table-column>
                  <el-table-column
                    label="收藏"
                    prop="sgL_NFavorite"
                  ></el-table-column> -->
                  <el-table-column
                    label="分享"
                    prop="sgL_Share"
                  ></el-table-column>
                  <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                      <el-button
                        type="success"
                        size="mini"
                        @click="UpdateRecommend(scope.row.id, 'remove')"
                        v-if="scope.row.sgL_Recommend == true"
                        >從推薦中移除</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="UpdateRecommend(scope.row.id, 'addstar')"
                        v-else
                        >加入推薦</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="edit(scope.row.id)"
                        >編輯</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        @click="
                          open(
                            $event,
                            scope.row.id,
                            `您確定將文章[${scope.row.sgL_Title}]刪除？`,
                            '刪除文章',
                            'del'
                          )
                        "
                        >刪除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="row">
                <div class="col-lg-4 offset-lg-7">
                  <!--  引用分页组件 -->
                  <pagination
                    v-if="pageParams.pageshow"
                    :currentPage="pageParams.currentPage"
                    :total="pageParams.total"
                    :limit="pageParams.limit"
                    :small="true"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                  />
                </div>
              </div>
              <!-- /.card-body -->
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import pagination from "../common/Page";
import { Message } from "element-ui";
export default {
  data() {
    return {
      //文章類型
      topicTypeList: [],
      //加載框
      isload: false,
      //數據列表
      TopicModel: [],
      //分页
      pageParams: {
        currentPage: 1,
        limit: 10,
        total: 2,
        pageshow: true,
      },
      //查询
      filterParam: {
        topicType: "",
        title: "",
        author: "",
        SGL_Recommend: null,
      },
    };
  },
  created() {
    this.GetArticleList();
    this.getArticleType();
  },
  watch: {
    "filterParam.title": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    "filterParam.author": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    "filterParam.SGL_Recommend": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },

    "filterParam.topicType": {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
  },
  methods: {
    GetArticleList() {
      let params = {
        SGL_MasterSort: this.filterParam.topicType,
        SGL_Recommend: this.filterParam.SGL_Recommend, //是否推荐
        sgL_DisplayName: this.filterParam.author,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        SGL_Title: this.filterParam.title,
      };
      this.$api.TopicApi.GetArticleList(params).then((res) => {
        if (res.data.success) {
          this.TopicModel = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
        }
      });
    },
    getArticleType() {
      let params = {
        SGL_TypeT: 10, //文章類型
      };
      this.$api.TopicApi.GetArticleType(params).then((res) => {
        if (res.data.success) {
          this.topicTypeList = res.data.result.items;
        }
      });
    },
    cellclick(row, column, $event, cell) {
      if (column.property == "sgL_DisplayName") {
        this.filterParam.author = row.sgL_DisplayName;
      }
      if (column.property == "sgL_MasterSortF") {
        this.filterParam.topicType = row.sgL_MasterSort;
      }
    },
    //加入推荐
    UpdateRecommend(id, func) {
      let params = {
        id: id,
      };
      if (func == "addstar") {
        this.$api.TopicApi.UpdateRecommend(params).then((res) => {
          if (res.data.success) {
            Message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
          } else {
            Message({
              type: "error",
              message: this.$t('message.operationfailure'),
            });
          }
          this.GetArticleList();
        });
      } else {
        this.$api.TopicApi.UnUpdateRecommend(params).then((res) => {
          if (res.data.success) {
            Message({
              type: "success",
              message: this.$t('message.operatesuccessfully'),
            });
          } else {
            Message({
              type: "error",
              message: this.$t('message.operationfailure'),
            });
          }
          this.GetArticleList();
        });
      }
    },
    //删除
    Delete(Id) {
      let params = {
        Id: Id,
      };
      this.$api.TopicApi.DelArticle(params).then((result) => {
        if (result.data.success) {
          Message({
            type: "success",
            message: "刪除成功",
          });
        } else {
          Message({
            type: "warning",
            message: result.data.error.message,
          });
        }
        this.handleCurrentChange(1);
      });
    },
    edit(id) {
      this.$router.push({ name: "articleAdd", query: { Id: id } });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.GetArticleList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetArticleList();
    },
    toArtivleAdd() {
      this.$router.push({ name: "articleAdd" });
    },
    //打开模态框
    open(e, Id, operator, title, method) {
      this.$confirm(operator, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (method == "removeFeatured" || method == "addFeatured") {
            await this.Choice(Id, method);
          } else {
            await this.Delete(Id);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "操作取消",
          });
        });
    },
  },
  computed: {
    getTopicModel() {
      return this.TopicModel;
    },
  },
  components: {
    pagination: pagination,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminTopic/TopicList.vue